"use client";

import {
  deleteCookie as deleteCookieNext,
  getCookie as getCookieNext,
  setCookie as setCookieNext,
} from "cookies-next";

const DEFAULT_EXPIRY_DAYS = 30; // 1 month
export const AUTH_USER_ID_COOKIE = "authUserId";

const AUTH_COOKIE_KEYS = [
  "accessToken",
  "refreshToken",
  "idToken",
  AUTH_USER_ID_COOKIE,
];

function shouldUseSecureCookies(): boolean {
  if (typeof window !== "undefined") {
    return window.location.protocol === "https:";
  }

  return process.env.NODE_ENV === "production";
}

/**
 * Get a cookie value by key
 */
export function getCookie(key: string): string | null {
  const value = getCookieNext(key);
  return typeof value === "string" ? value : null;
}

/**
 * Set a cookie with optional expiry (in days)
 */
export function setCookie(
  key: string,
  value: string,
  days: number = DEFAULT_EXPIRY_DAYS
): void {
  const expires = new Date();
  expires.setDate(expires.getDate() + days);

  setCookieNext(key, value, {
    expires, // cookie expiry date
    path: "/", // available throughout the app
    sameSite: "lax", // prevent CSRF
    secure: shouldUseSecureCookies(),
  });
}

/**
 * Set a cookie with a max-age in seconds.
 */
export function setCookieWithMaxAge(
  key: string,
  value: string,
  maxAgeSeconds: number
): void {
  setCookieNext(key, value, {
    maxAge: maxAgeSeconds,
    path: "/",
    sameSite: "lax",
    secure: shouldUseSecureCookies(),
  });
}

/**
 * Delete a cookie by key
 */
export function deleteCookie(key: string): void {
  deleteCookieNext(key, { path: "/" });
}

export function clearAuthCookies(): void {
  AUTH_COOKIE_KEYS.forEach((key) => deleteCookie(key));
}
